// extracted by mini-css-extract-plugin
export default {"revenueCard":"revenueCard_revenueCard__vpe2L","lightText":"revenueCard_lightText__tWxjL","amount":"revenueCard_amount__pWaeQ","title1":"revenueCard_title1__w-u4q"};